export * from './formular-entfernt.interface';
